<template>
  <validation-provider :vid="vid"
    :name="$attrs.label"
    :rules="rules"
    #default="slotProps"
  >
    <a-form-item
      :label="$attrs.label"
      :validate-status="resolveState(slotProps)"
      :help="slotProps.errors[0]"
    >
      <a-select :placeholder="$attrs.placeholder || '请选择'" :options="$attrs.options" v-model="modelValue">
        <slot />
      </a-select>
    </a-form-item>
  </validation-provider>
</template>

<script>
import { computed } from '@vue/composition-api'
import { resolveState } from '@/utils/tools'

export default {
  name: 'SelectWithValidation',
  props: {
    vid: String,
    rules: {
      type: [Object, String],
      default: ''
    },
    value: null
  },
  emits: ['input'],
  setup (props, { emit }) {
    const modelValue = computed(() => ({
      get: () => props.value,
      set: value => {
        emit('input', value)
      }
    }))
    return {
      modelValue,
      resolveState
    }
  }
}
</script>
